<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 fixContainerHeight-->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="web/equipment/check/standard/group/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('dianjianfenzu')" rexiauired>
						<el-input type="text" v-model="yt.conditions.group"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_base_check_standard_create')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setMaintainType()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button v-if="utils.checkPower('web_base_check_standard_reset')" size="mini" @click="yt.showEditDialog('chongzhidianjianbiaozhun',null,'80%')" plain>
					{{$t('chongzhidianjianbiaozhun')}}
				</el-button>
				<el-button v-if="utils.checkPower('web_base_check_standard_import_group_detail')" size="mini" @click="showImportExcelGroupDetail = !showImportExcelGroupDetail" plain>
					{{$t('daorudianjianfenzu-mingxi')}}
				</el-button>
				<el-button v-if="utils.checkPower('web_base_check_standard_import_group_equipment')" size="mini" @click="showImportExcelGroupEquipment = !showImportExcelGroupEquipment" plain>
					{{$t('daorudianjianfenzu-shebei')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_check_standard_group_item')" type="text" @click="yt.showEditDialog('dianjianmingxi', scope.row,'80%')">
							{{$t('dianjianmingxi')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_check_standard_group_equipment')" type="text" @click="yt.showEditDialog('shebei', scope.row,'80%')">
							{{$t('shebei')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/standard/group/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('dianjianfenzu')">
						<el-input type="text" v-model="yt.editObj.group" size="mini"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/equipment/check/standard/group/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 保养明细弹窗 -->
			<template v-if="yt.editObj.action == 'dianjianmingxi'">
				<div class="dialog-scroller">
					<check_standard_group_item :group="yt.editObj"></check_standard_group_item>
				</div>
			</template>
			<!-- 设备弹窗 -->
			<template v-if="yt.editObj.action == 'shebei'">
				<div class="dialog-scroller">
					<check_standard_group_equipment :group="yt.editObj"></check_standard_group_equipment>
				</div>
			</template>
			<template v-if="yt.editObj.action=='chongzhidianjianbiaozhun'">
				<div class="dialog-scroller">
					<yi_cross_select :component="'web_base_equipment_list'" :max="200" multiple
						:ids.sync="yt.editObj.equipmentIds" :isInput="false"></yi_cross_select>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/equipment/check/standard/group/reset')" type="primary">
						{{$t('quedingchongzhi')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
		<import_excel_group_detail :show.sync="showImportExcelGroupDetail"/>
		<import_excel_group_equipment :show.sync="showImportExcelGroupEquipment"/>

	</div>
</template>

<script>
	import check_standard_group_item from '@@/pages/web/base/check_standard/check_standard_group_item'
	import check_standard_group_equipment from '@@/pages/web/base/check_standard/check_standard_group_equipment'
	import import_excel_group_detail from '@@/pages/web/base/check_standard/import_excel_group_detail'
	import import_excel_group_equipment from '@@/pages/web/base/check_standard/import_excel_group_equipment'
	export default {
		name: 'web_base_check_standard_group_list',
		components: {
			check_standard_group_item,
			check_standard_group_equipment,
			import_excel_group_detail,
			import_excel_group_equipment,
		},
		created() {
			setTimeout(() => {
				this.utils.event_hub.$on('EQUIPMENT_CHECK_STANDARD_GROUP_LIST', () => {
					this.yt.get(1);
				})
				this.yt.get(1);
			}, 300)
		},
		data() {
			return {
				options: [{
					label: this.$t('nian'),
					value: 1
				}, {
					label: this.$t('yue'),
					value: 2
				}, {
					label: this.$t('zhou'),
					value: 3
				}, {
					label: this.$t('tian'),
					value: 4
				}],
				list: [],
				organizationList: [],
				customerList: [],
				shiftList: [],
				maintainTypeList: [],
				columns: [{
					label: 'dianjianfenzu',
					prop: 'group',
				}, {
					label: 'caozuo',
					type: 'slot',
				}],
				isShowAddCycleDialog: false,
				isShowEditCycleDialog: false,
				labelWidth: "100px",
				timeList: [],
				showImportExcelGroupDetail: false,
				showImportExcelGroupEquipment: false,
			}
		},

		methods: {
		
		},

	};
</script>
